import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Grid, Stack, Box, IconButton, IconButtonProps, styled } from '@mui/material';
import { useState } from 'react';
import { ICandidate, amplitude } from 'wisestep-api';
import {
  WsColors,
  WsTypography,
  WsTypoColors,
  WsButton,
  WsIconCopy,
  WsIconText,
  WsIconCalendarOutline,
  formateDateInDateMonth,
} from 'wisestep-base';

import CompletedLogo from '../../../../images/complete.svg';
import PendingLogo from '../../../../images/pending.svg';
import { success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import { copyStringToClipboard } from '../childComponets/CandidateDetailsCard/Helper';
import RecruiterQuestionDetails from '../childComponets/RecruiterQuestionDetails/RecruiterQuestionDetails';
interface IQuestionResponse {
  question: string;
  answer: string;
}

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}
const ExpandMore = styled((props: ExpandMoreProps) => {
  const { ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(90deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

interface IQuestionResponseTable {
  candidateInteraction: ICandidate;
}
const QuestionResponseTable = ({ candidateInteraction }: IQuestionResponseTable) => {
  const setNotification = useNotificationStore((state) => state.setNotification);

  const [expandQuestion, setExpandQuestion] = useState<boolean>(false);

  const copyQA = (value: IQuestionResponse[]) => {
    const header = ['Question', 'Answer'];
    const rows = value.map((item) => [item.question, item.answer]);
    const output = [header.join('\t'), ...rows.map((row) => row.join('\t'))].join('\n') + '\n';
    copyStringToClipboard(output);
    setNotification(success('Copied Successfully !!'));
  };

  const onCopy = () => {
    candidateInteraction?.questionResponse && copyQA(candidateInteraction?.questionResponse ?? []);
    amplitude('Copy_Recruiter_Questions', {
      clickedOn: 'Copy Button',
      pageName: 'candidate-layout',
      pageUrl: window.location.href,
    });
  };

  return (
    <Grid
      container
      mt={2}
      px={1}
      sx={{
        minHeight: 30,
        display: 'flex',
        alignItems: 'center',
        backgroundColor: WsColors.White,
        borderRadius: 2,
        border: '1px solid',
        borderColor: WsColors.TertiaryShades500,
      }}
    >
      <Grid
        container
        xs={3}
        p={1}
        sx={{
          backgroundColor: WsColors.White,
          cursor: 'pointer',
        }}
        onClick={() => setExpandQuestion(!expandQuestion)}
      >
        <Grid item xs={3}>
          <ExpandMore
            expand={expandQuestion}
            aria-expanded={expandQuestion}
            aria-label="show more"
            sx={{ padding: 0 }}
          >
            <PlayArrowIcon htmlColor={expandQuestion ? WsColors.TheBlues500 : WsColors.GreyBlack} />
          </ExpandMore>
        </Grid>
        <Grid item xs={9} display="flex" alignItems="center" alignContent="center">
          <WsTypography
            color={expandQuestion ? WsTypoColors.PRIMARY : WsTypoColors.SECONDARY}
            bold
            cursor="pointer"
          >
            Recruiter Questions
          </WsTypography>
        </Grid>
      </Grid>
      <Grid item container direction="row" alignItems="flex-end" justifyContent="flex-end" xs={9}>
        {expandQuestion ? (
          <Stack marginTop={1} direction="row" justifyContent="flex-end">
            <WsButton
              variant="outlined"
              size="small"
              onClick={onCopy}
              startIcon={<WsIconCopy color={WsColors.TheBlues500} />}
            >
              Copy
            </WsButton>
          </Stack>
        ) : (
          <>
            <WsIconText
              icon={<WsIconCalendarOutline />}
              text={formateDateInDateMonth(candidateInteraction?.createdOn ?? '')}
            />
            <img
              src={
                candidateInteraction?.questionResponse &&
                candidateInteraction?.questionResponse?.length > 0
                  ? CompletedLogo
                  : PendingLogo
              }
              alt="Logo"
              style={{
                width: 100,
                height: 30,
                marginRight: 8,
              }}
            />
          </>
        )}
      </Grid>
      {expandQuestion && candidateInteraction && (
        <>
          <Box
            px={4}
            sx={{
              minHeight: 40,
              display: 'flex',
              alignItems: 'center',
              backgroundColor: WsColors.White,
            }}
          >
            {candidateInteraction && (
              <>
                <WsTypography color={WsTypoColors.SECONDARY}>Submitted by :</WsTypography>
                <WsTypography>
                  {candidateInteraction?.contactActionsObjs?.at(0)?.createdBy}
                </WsTypography>
                <WsTypography color={WsTypoColors.SECONDARY}>
                  (on {formateDateInDateMonth(candidateInteraction?.createdOn ?? '')})
                </WsTypography>
              </>
            )}
          </Box>
          <RecruiterQuestionDetails candidate={candidateInteraction} />
        </>
      )}
    </Grid>
  );
};

export default QuestionResponseTable;
